import React from 'react';
import { TOKENS, RADIUS } from '../lib/theme.js';

// BRAND.md §8.6: every async view gets a skeleton — no spinner-only screens.
// Shimmer collapses to a static block under prefers-reduced-motion (global
// rule in src/styles/tokens/elevation.css).

const base = {
  background: `linear-gradient(90deg, ${TOKENS.line} 25%, ${TOKENS.sageWash} 50%, ${TOKENS.line} 75%)`,
  backgroundSize: '200% 100%',
  animation: 'sedra-shimmer 1.4s ease infinite',
};

export function SkeletonBlock({ width = '100%', height = 16, radius = RADIUS.sm, style }) {
  return <div aria-hidden="true" style={{ ...base, width, height, borderRadius: radius, ...style }} />;
}

export function SkeletonText({ lines = 2, width = '100%', style }) {
  return (
    <div aria-hidden="true" style={style}>
      {Array.from({ length: lines }).map((_, i) => (
        <SkeletonBlock
          key={i}
          height={12}
          width={i === lines - 1 ? '60%' : width}
          style={{ marginBottom: 8 }}
        />
      ))}
    </div>
  );
}

// Product-card shaped skeleton (BRAND.md §8.2 proportions: 1:1 image well)
export function SkeletonCard() {
  return (
    <div aria-hidden="true" style={{
      background: TOKENS.card, borderRadius: RADIUS.md, overflow: 'hidden',
      boxShadow: '0 1px 3px rgba(0,42,23,.08)',
    }}>
      <SkeletonBlock height={0} radius={0} style={{ paddingTop: '100%' }} />
      <div style={{ padding: 16 }}>
        <SkeletonText lines={2} />
        <SkeletonBlock width="40%" height={18} style={{ marginTop: 10 }} />
      </div>
    </div>
  );
}

export function SkeletonGrid({ count = 8, columns }) {
  return (
    <div style={{
      display: 'grid', gap: 16,
      gridTemplateColumns: columns || 'repeat(auto-fill, minmax(200px, 1fr))',
    }}>
      {Array.from({ length: count }).map((_, i) => <SkeletonCard key={i} />)}
    </div>
  );
}
